import SampleTypeModel from "@/models/lab/SampleTypeModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class SampleTypeCollection extends LabServiceCollection {
  model() {
    return SampleTypeModel;
  }

  methods() {
    return {
      fetch: "GET",
      save: "POST",
      delete: "DELETE",
      getIndicatorCount: "GET"
    };
  }

  routes() {
    const model = (new (this.model())());
    const routes = super.routes();

    routes['getIndicatorCount'] = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${model.modelName()}/indicator-count`;

    return routes;
  }

  getIndicatorCount() {
    const method = this.getOption('methods.getIndicatorCount');
    const route = this.getRoute('getIndicatorCount');
    const url = this.getURL(route);

    return this.createRequest({method, url}).send()
      .then(this.handleCustomFetchSuccess)
      .catch(this.handleCustomFetchFailure)
  }

}
